import { set } from 'lodash';
import {
    hiddenColumnType,
    leftPinnedColumn,
    numericColumn,
    toggleColumn,
} from 'modules/campaigns/modules/campaigns-reports/config/columns';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import { updatePushApiState } from 'modules/push-api/flows/updatePushApiState';
import { PUSH_API_STATUS, isPushApiStatusActive } from 'modules/push-api/utils/subscriptionConsts';
import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components';
import { PushApiReportActionsCellRenderer } from '../../../components/CellRenderers/PushApi/PushApiReportActionsCellRenderer';
import { PushApiStateCellRenderer } from '../../../components/CellRenderers/PushApi/PushApiStateCellRenderer';
import { actionsColumnType, rightPinnedColumn, staticColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { PUSH_API_REPORT_ID } from './pushApiReportId';

const isDisabled = data => {
    return !data.accountId;
};

const pushApiReportColumnDefinitions = [
    {
        headerName: FIELDS.ID.label,
        field: FIELDS.ID.field,
        type: [hiddenColumnType, numericColumn],
    },
    {
        headerName: FIELDS.IS_ACTIVE.label,
        field: FIELDS.IS_ACTIVE.field,
        type: [toggleColumn, leftPinnedColumn, actionsColumnType, staticColumn],
        cellRendererParams: {
            ...FIELDS.IS_ACTIVE.renderParams,
            isDisabled,
            reportId: PUSH_API_REPORT_ID,
        },
        cellRenderer: PushApiStateCellRenderer,
        csv: false,
        minWidth: 36,
        maxWidth: 50,
        valueGetter: ({ data }) => {
            const { status } = data;
            return status;
        },
        valueSetter: params =>
            set(params, 'data.status', params.newValue ? PUSH_API_STATUS.APPROVED : PUSH_API_STATUS.PENDING),
        valueChangeHandler: (_, { id, accountId }, __, ___, status) =>
            updatePushApiState({
                accountId,
                subscription: {
                    id,
                    isActive: isPushApiStatusActive(status),
                },
            }),
    },
    {
        headerName: FIELDS.PUSH_API_STATUS.label,
        headerValueGetter: FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: FIELDS.PUSH_API_STATUS.headerComponentParams,
        field: FIELDS.PUSH_API_STATUS.field,
        cellRenderer: FIELDS.PUSH_API_STATUS.cellRenderer,
        cellRendererParams: FIELDS.PUSH_API_STATUS.cellRendererParams,
    },
    {
        headerName: FIELDS.PUSH_API_SUB_NAME.label,
        field: FIELDS.PUSH_API_SUB_NAME.field,
        valueFormatter: FIELDS.PUSH_API_SUB_NAME.valueFormatter,
    },
    {
        headerName: FIELDS.PUSH_API_ENDPOINTS.label,
        field: FIELDS.PUSH_API_ENDPOINTS.field,
        valueFormatter: FIELDS.PUSH_API_ENDPOINTS.valueFormatter,
        cellRenderer: FIELDS.PUSH_API_ENDPOINTS.cellRenderer,
        width: 210,
        minWidth: 210,
    },
    {
        headerName: FIELDS.PUSH_API_ACCOUNT_NAME.label,
        field: FIELDS.PUSH_API_ACCOUNT_NAME.field,
        cellRenderer: FIELDS.PUSH_API_ACCOUNT_NAME.cellRenderer,
    },
    {
        headerName: FIELDS.PUSH_API_PERFORMER.label,
        field: FIELDS.PUSH_API_PERFORMER.field,
    },
    {
        headerName: FIELDS.PUSH_API_LAST_MODIFY_ON_UPDATE_TIME.label,
        field: FIELDS.PUSH_API_LAST_MODIFY_ON_UPDATE_TIME.field,
        valueFormatter: FIELDS.PUSH_API_LAST_MODIFY_ON_UPDATE_TIME.valueFormatter,
    },
    {
        headerName: FIELDS.ACTIONS_COLUMN.label,
        field: FIELDS.ACTIONS_COLUMN.field,
        valueGetter: params => params.data,
        type: [rightPinnedColumn, actionsColumnType, staticColumn],
        cellRenderer: PushApiReportActionsCellRenderer,
        csv: false,
        minWidth: 50,
        width: 50,
    },
];

export const columnDefinitions = normalizeColumnDefs(pushApiReportColumnDefinitions, PUSH_API_REPORT_ID);
